import Component from "@glimmer/component";
import { service } from "@ember/service";
import { on } from "@ember/modifier";
import { t } from "ember-intl";
import { and } from "ember-truth-helpers";
import { task } from "ember-concurrency";
import dayjs from "dayjs";
import Box from "glesys-controlpanel/components/box";
import BoxEmptyState from "glesys-controlpanel/components/box/empty-state";
import Table from "glesys-controlpanel/components/table";
import TableTd from "glesys-controlpanel/components/table/td";
import GButton from "glesys-controlpanel/components/g-button";
import canManage from "glesys-controlpanel/helpers/can-manage";
import { findRecord } from "@warp-drive/legacy/compat/builders";

export default class DatabasePitrBox extends Component {
  @service intl;
  @service modal;
  @service store;

  get database() {
    return this.args.database;
  }

  openRestoreTask = task(async () => {
    await this.store.request(findRecord("database", this.database.id, { reload: true })).catch(() => {});
    this.modal.open("modals/database-restore", { database: this.database, project: this.args.project });
  });

  get rows() {
    let pitr = this.database.pitr;
    let window = pitr.restorewindow;

    return [
      {
        key: this.intl.t("databases.details.pitr.table.retention"),
        value: this.intl.t("databases.details.pitr.table.days", { days: pitr.retentiondays }),
      },
      {
        key: this.intl.t("databases.details.pitr.table.latest"),
        value: dayjs(window.latest).format("YYYY-MM-DD HH:mm"),
      },
      {
        key: this.intl.t("databases.details.pitr.table.earliest"),
        value: dayjs(window.earliest).format("YYYY-MM-DD HH:mm"),
      },
    ];
  }

  <template>
    {{#if @database.hasPitr}}
      <Box data-test-database-details-pitr @showFooter={{and @database.pitrIsEnabled (canManage)}}>
        <:header>{{t "databases.details.pitr.title"}}</:header>
        <:default>
          {{#if @database.pitrIsInitializing}}
            <BoxEmptyState
              data-test-database-pitr-initializing
              @title={{t "databases.details.pitr.initializing-title"}}
              @description={{t "databases.details.pitr.initializing"}}
            />
          {{else}}
            <span class="text-gray-500 text-base">{{t "databases.details.pitr.description"}}</span>
            <Table class="mx-[-24px] mt-8" @items={{this.rows}} @footer={{false}} @outsideBorders={{false}}>
              <:body as |item|>
                <TableTd class="w-1/3 text-gray-600">{{item.key}}</TableTd>
                <TableTd data-test-database-pitr-value>{{item.value}}</TableTd>
              </:body>
            </Table>
          {{/if}}
        </:default>
        <:footer>
          <GButton
            data-test-database-pitr-restore
            @color="outline"
            @loading={{this.openRestoreTask.isRunning}}
            {{on "click" this.openRestoreTask.perform}}
          >
            {{t "button.restore"}}
          </GButton>
        </:footer>
      </Box>
    {{/if}}
  </template>
}
